export default class CanalEmailStatusEnum {
    static Ok = 1
    static FalhaAutenticacao = 2
}
